const config = {
    apiUrl: "/api/",
    enableFeatureX: true,
    defaultLanguage: "de",
  };
  
  export default config;